import { useState, useEffect } from 'react';
import { LocationService } from '../services/driverlocation.service';
import { DriverLocation, DriverLocations, Location } from '../types/location.types';

export const useLocations = () => {
  const [locations, setLocations] = useState<DriverLocations>({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    const unsubscribe = LocationService.subscribeToDriverLocations((driverLocations) => {
      // Transform DriverLocation to Location format for compatibility
      const transformedLocations: DriverLocations = {};
      
      Object.entries(driverLocations).forEach(([driverId, driverLocation]) => {
        transformedLocations[driverId] = {
          lat: driverLocation.latitude,
          lng: driverLocation.longitude,
          speed: driverLocation.speed,
          heading: driverLocation.heading,
          accuracy: driverLocation.accuracy,
          lastUpdate: driverLocation.lastUpdated,
          status: driverLocation.status,
          appState: driverLocation.appState
        };
      });
      
      setLocations(transformedLocations);
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return {
    locations,
    loading,
    error
  };
};

// Hook for subscribing to a specific driver's location
export const useDriverLocation = (driverId: string | null) => {
  const [location, setLocation] = useState<DriverLocation | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!driverId) {
      setLocation(null);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = LocationService.subscribeToDriverLocation(driverId, (driverLocation) => {
      setLocation(driverLocation);
      setLoading(false);
    });

    return () => {
      unsubscribe();
    };
  }, [driverId]);

  return {
    location,
    loading,
    error
  };
};